import React from 'react'
import { Card, Stack, Text } from '@mantine/core'
import EmptyMetric from './EmptyMetric'
import i18n from 'live/services/i18n'
import { MetricParams } from 'plugin-product-frac-ui/shared/registries/metrics-registry'
import useGetAggregatedStages from '../../services/kpis/hooks/useGetAggregatedStages'

type AverageMetricProps = {
    metricType: 'average'
    params: MetricParams
}

type PercentageMetricProps = {
    metricType: 'percentage'
    params: MetricParams
}

type MetricsCardProps = AverageMetricProps | PercentageMetricProps

const MetricsCard: React.FC<MetricsCardProps> = props => {
    const { metricType } = props
    const { data, loading, error } = useGetAggregatedStages({
        params: props.params,
        lookbackDays: 1
    })

    const isEmpty = !loading && (!!error || data === undefined)

    if (loading) {
        return (
            <Card radius="md" p="lg">
                <Stack spacing={2} align="center">
                    <Text size="sm">{i18n('Loading...')}</Text>
                </Stack>
            </Card>
        )
    }

    if (isEmpty) {
        return (
            <Card radius="md" p="lg">
                <EmptyMetric metricType={metricType === 'average' ? 'stages' : 'average'} />
            </Card>
        )
    }

    let value: React.ReactNode = '-'
    let label = ''

    if (metricType === 'average') {
        value = `${data?.count ?? 0}/${data?.total_planned ?? 0}`
        label = 'Stages completed'
    }
    if (metricType === 'percentage') {
        value = `${(data?.pumping_percentage ?? 0).toFixed(1)} min`
        label = 'AVG. Pump time per stage'
    }

    return (
        <Card radius="md" p="lg">
            <Stack spacing={2} align="center">
                <Text size="3.75rem" weight={700} sx={{ lineHeight: 1.1 }} color="var(--mantine-text-default)">
                    {value}
                </Text>
                <Text size="lg" ta="center" fw={500} lh="1.2" color="var(--mantine-text-default)">
                    {label}
                </Text>
                <Text size="xs" ta="center" tt="uppercase" fw={500} color="var(--mantine-text-subtle)">
                    {i18n('In the last 24 hours')}
                </Text>
            </Stack>
        </Card>
    )
}

export default MetricsCard
